{
  "ActivationPage": {
    "checkingYourActivationLink": "Checking your activation link…",
    "activateStaffAccount": "Activate Staff Account",
    "chooseYourSignInPassword": "Choose your sign-in password.",
    "activationLinkUnavailable": "Activation link unavailable",
    "askAnAdministratorToSendYouA": " Ask an administrator to send you a new activation link.",
    "continueToVerifyYourInvitationAndChoose": "Continue to verify your invitation and choose your sign-in password.",
    "continueToPasswordSetup": "Set Password",
    "staffAccountFound": "Staff account found",
    "thisLinkIsFor": "This link is for ",
    "accountEmail": "Account Email",
    "thisSetupLinkIsBoundToThis": "This setup link is bound to this address, which cannot be changed here.",
    "password": "Password",
    "useAtLeast8Characters": "Use at least 8 characters.",
    "confirmPassword": "Confirm Password",
    "activateAccount": "Activate Account",
    "thisActivationLinkIsMissingOrIncomplete": "This activation link is missing or incomplete.",
    "thisActivationLinkIsNotValid": "This activation link is not valid.",
    "thisActivationLinkHasExpiredOrHas": "This activation link has expired or has already been used.",
    "thisAccountIsNotAvailableForActivation": "This account is not available for activation.",
    "thisActivationLinkDoesNotMatchThe": "This activation link does not match the staff account that was provisioned.",
    "accountActivationIsTemporarilyUnavailablePleaseTry": "Account activation is temporarily unavailable. Please try the link again later.",
    "yourPasswordCouldNotBeSetChoose": "Your password could not be set. Choose a different password or request a new activation link.",
    "yourPasswordCouldNotBeSetCheck": "Your password could not be set. Check your connection and try again.",
    "yourPasswordIsReadySignInTo": "Your password is ready. Sign in to complete staff access checks.",
    "chooseAPasswordWithAtLeast8": "Choose a password with at least 8 characters.",
    "passwordsDoNotMatch": "Passwords do not match.",
    "welcome": "Welcome, {{name}}"
  },
  "guards": {
    "checkingYourSession": "Checking your session…",
    "yourAccountIsActiveButItHas": "Your account is active, but it has no portal capabilities. Ask an administrator to review your role.",
    "youHaveBeenSignedOut": "You have been signed out."
  },
  "LoginPage": {
    "staffSignIn": "Staff Sign In",
    "signOut": "Sign Out",
    "accessToken": "Access Token",
    "mockAuthIsEnabledOnThisServer": "Mock auth is enabled on this server (local development only).",
    "pastePortalMockToken": "paste PORTAL_MOCK_TOKEN",
    "signInIsNotConfigured": "Sign-in is not configured",
    "signInIsTemporarilyUnavailableContactAn": "Sign-in is temporarily unavailable. Contact an administrator for help.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "forgotPassword": "Forgot password?",
    "enterTheLocalAccessToken": "Enter the local access token.",
    "enterAValidEmailAddress": "Enter a valid email address.",
    "enterYourPassword": "Enter your password.",
    "signInCouldNotBeCompletedCheck": "Sign-in could not be completed. Check your connection and try again.",
    "youHaveBeenSignedOutReopenYour": "You have been signed out. Reopen your latest confirmation email, or sign in if your email is already confirmed.",
    "accountHint": "Use your {{productName}} staff account."
  },
  "MeProvider": {
    "loadingYourSession": "Loading your session…",
    "signingOut": "Signing out…",
    "couldNotLoadYourSession": "Could not load your session",
    "thePortalApiDidNotRespondCheck": "The portal API did not respond. Check that the server is running, then retry.",
    "thisAccountHasBeenDisabledContactAn": "This account has been disabled. Contact an administrator.",
    "yourStaffAccountIsStillBeingSet": "Your staff account is still being set up. Ask an administrator to complete its activation, then sign in again.",
    "thisAccountIsNotProvisionedForThe": "This account is not provisioned for the portal. Ask an administrator to add you.",
    "youHaveBeenSignedOut": "You have been signed out."
  },
  "MfaPage": {
    "twoFactorAuthentication": "Two-Factor Authentication",
    "signedInAs": "Signed in as ",
    "protectYourStaffAccountWithAnAuthenticator": "Protect your staff account with an authenticator app.",
    "notAvailableInMockAuthMode": "Not available in mock auth mode",
    "totpEnrollmentAndChallengesRunThroughSupabase": "TOTP enrollment and challenges run through Supabase Auth. Start the server with a real Supabase project (`PORTAL_AUTH_MODE` unset) to use them.",
    "loadingMfaStatus": "Loading MFA status…",
    "verificationRequired": "Verification required",
    "yourSessionMustBeVerifiedWithA": "Your session must be verified with a second factor before you can continue.",
    "verified": "Verified",
    "thisSessionIsNowProtectedWithTwo": "This session is now protected with two-factor authentication.",
    "thisSession": "This Session",
    "verifiedAal2": "Verified (aal2)",
    "passwordOnlyAal1": "Password only (aal1)",
    "authenticator": "Authenticator",
    "enrolled": "Enrolled",
    "notEnrolled": "Not enrolled",
    "policy": "Policy",
    "added": "added {{date}}",
    "remove": "Remove",
    "supabaseTotpHasNoRecoveryCodesIf": "Supabase TOTP has no recovery codes. If you lose the device, an administrator resets the factor server-side.",
    "enterTheCodeFromYourAuthenticatorApp": "Enter the code from your authenticator app",
    "verify": "Verify",
    "youWillScanAQrCodeWith": "You will scan a QR code with an authenticator app (1Password, Google Authenticator, Authy, Microsoft Authenticator…) and confirm with a 6-digit code.",
    "setUpAuthenticator": "Set Up Authenticator",
    "authenticatorEnrollmentQrCode": "Authenticator enrollment QR code",
    "canTScanTheCode": "Can’t scan the code?",
    "enterThisSecretManually": "Enter this secret manually:",
    "totpSecret": "TOTP secret",
    "openInAnAuthenticatorApp": "Open Authenticator",
    "cancel": "Cancel",
    "confirmAndEnable": "Confirm and Enable",
    "signOut": "Sign Out",
    "continueToThePortal": "Open Portal",
    "message6DigitCode": "6-Digit Code",
    "message1ScanThisCode": "1. Scan this code",
    "message2EnterThe6DigitCodeIt": "2. Enter the 6-digit code it shows",
    "couldNotLoadMfaStatus": "Could not load MFA status.",
    "unexpectedEnrollmentResponse": "Unexpected enrollment response.",
    "couldNotStartEnrollment": "Could not start enrollment.",
    "enterThe6DigitCodeFromYour": "Enter the 6-digit code from your authenticator app.",
    "thatCodeDidNotWorkTryThe": "That code did not work. Try the next one.",
    "couldNotRemoveTheAuthenticator": "Could not remove the authenticator.",
    "requiredNow": "Required now",
    "optional": "Optional",
    "notReportedByTheServerYet": "Not reported by the server yet",
    "youHaveBeenSignedOut": "You have been signed out.",
    "requiredUntil": "Required — grace ends {{date}}",
    "required": "Required",
    "authenticatorApp": "Authenticator app"
  },
  "PasswordRecoveryPage": {
    "backToSignIn": "Back to Sign In",
    "forgotPassword": "Forgot password?",
    "ifAnAccountExistsForThatEmail": "If an account exists for that email address, you will receive a password reset link. Check your inbox and spam folder.",
    "passwordRecoveryIsUnavailableInThisEnvironment": "Password recovery is unavailable in this environment.",
    "enterTheEmailAddressYouUseTo": "Enter the email address you use to sign in.",
    "email": "Email",
    "sendResetLink": "Send Reset Link",
    "checkingYourPasswordResetLink": "Checking your password reset link…",
    "resetYourPassword": "Reset Your Password",
    "yourPasswordHasBeenChangedSignIn": "Your password has been changed. Sign in with your new password to continue. Existing approval and access requirements still apply.",
    "resetLinkUnavailable": "Reset link unavailable",
    "thisResetLinkHasExpiredOrHas": "This reset link has expired or has already been used.",
    "thisResetLinkIsMissingInvalidOr": "This reset link is missing, invalid or expired.",
    "requestANewResetLink": "Request Reset Link",
    "continueToVerifyYourResetLinkAnd": "Continue to verify your reset link and choose your password.",
    "continueToPasswordSetup": "Set Password",
    "verifiedEmail": "Verified Email",
    "newPassword": "New Password",
    "useAtLeast8Characters": "Use at least 8 characters.",
    "confirmPassword": "Confirm Password",
    "setNewPassword": "Set New Password",
    "enterAValidEmailAddress": "Enter a valid email address.",
    "pleaseWaitAMinuteBeforeRequestingAnother": "Please wait a minute before requesting another reset link.",
    "weCouldNotRequestAResetLink": "We could not request a reset link. Please wait a minute and try again.",
    "chooseAPasswordWithAtLeast8": "Choose a password with at least 8 characters.",
    "passwordsDoNotMatch": "Passwords do not match.",
    "yourPasswordCouldNotBeChangedTry": "Your password could not be changed. Try a different password or request a new reset link.",
    "yourPasswordCouldNotBeChangedCheck": "Your password could not be changed. Check your connection and try again."
  },
  "ViewAsBoundary": {
    "portalPreview": "Portal preview",
    "viewingPortalAs": "Viewing portal as {{name}}",
    "readOnlyPreviewExplicitPublicLinkCreation": "Read-only preview · Explicit public-link creation acts as administrator. Reloading returns to your admin view.",
    "returnToAdministrator": "Return to Administrator",
    "changingPortalView": "Changing portal view…",
    "yourAdministratorSessionNeedsTwoFactorVerification": "Your administrator session needs two-factor verification. Return to administrator to verify and restart this preview.",
    "accountSecurityAndOnboardingAreUnavailableDuring": "Account security and onboarding are unavailable during a read-only preview. Return to administrator to continue."
  },
  "joinConfirmation": {
    "anotherAccountIsSignedInSignOut": "Another account is signed in. Sign out, then reopen your email confirmation link or sign in with the account you confirmed.",
    "thisConfirmationLinkHasExpiredOrHas": "This confirmation link has expired or has already been used.",
    "weCouldNotReachTheAccountService": "We could not reach the account service to confirm this link.",
    "emailConfirmationWasInterruptedBeforeYourAccount": "Email confirmation was interrupted before your account could be signed in.",
    "thisConfirmationLinkIsIncompleteOrInvalid": "This confirmation link is incomplete or invalid.",
    "failureGuidance": "{{reason}} If your email is already confirmed, sign in below. Otherwise, reopen your latest confirmation email or contact account support for a new link."
  },
  "SessionProvider": {
    "couldNotSignInCheckYourEmail": "Could not sign in. Check your email and password.",
    "incorrectEmailOrPassword": "Incorrect email or password.",
    "confirmYourEmailBeforeSigningIn": "Confirm your email before signing in.",
    "tooManyAttemptsPleaseWaitAMoment": "Too many attempts. Please wait a moment and try again.",
    "couldNotReachTheSignInService": "Could not reach the sign-in service. Check your connection and try again.",
    "yourSessionHasExpiredPleaseSignIn": "Your session has expired. Please sign in again.",
    "portalSignInIsNotConfiguredAsk": "Portal sign-in is not configured. Ask an admin to set the Supabase URL and publishable key."
  }
}
